import { api, unwrap } from '@/data/api/client';
import type { ReferralOverview, ReferralCollectResult } from '@/domain/types';

export const referralsRepo = {
  overview: () => unwrap<ReferralOverview>(api.GET('/referral', {})),
  collect: () => unwrap<ReferralCollectResult>(api.POST('/referral/collect', {})),
  // Attach a referrer after sign-up (for users who didn't enter a code at registration).
  redeem: (refCode: number) =>
    unwrap(api.POST('/referral/redeem', { body: { refCode } })),
};
